import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@src/redux/hooks';
import { logout } from '@src/redux/authenticator';

import { TCurrentPages, SidebarView } from './SidebarView';
import { UserData } from '../Layout/Layout';
import { NAVIGATION_ITEMS } from '@src/constants/navigation';

export type TSidebarContainer = {
  currentPage: TCurrentPages;
  userData: UserData | null;
  isLoadingUser: boolean;
  isExpanded: boolean;
  onToggleExpanded: () => void;
  isMobile: boolean;
  isMobileOpen: boolean;
  onOpenMobile: () => void;
  onCloseMobile: () => void;
};

export const SidebarContainer = ({
  currentPage,
  userData,
  isLoadingUser,
  isExpanded,
  onToggleExpanded,
  isMobile,
  isMobileOpen,
  onOpenMobile,
  onCloseMobile,
}: TSidebarContainer) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleNavigateTo = (page: TCurrentPages) => {
    if (currentPage === page) return;

    if (page === 'home') {
      navigate('/');
    } else {
      const item = NAVIGATION_ITEMS.find((item) => item.id === page);
      if (item) {
        navigate(item.route);
      }
    }
  };

  const handleNavigateToProfile = () => {
    navigate('/profile');
  };

  return (
    <SidebarView
      currentPage={currentPage}
      userData={userData}
      isLoadingUser={isLoadingUser}
      isExpanded={isExpanded}
      onToggleExpanded={onToggleExpanded}
      isMobile={isMobile}
      isMobileOpen={isMobileOpen}
      onOpenMobile={onOpenMobile}
      onCloseMobile={onCloseMobile}
      onLogout={handleLogout}
      onNavigateTo={handleNavigateTo}
      onNavigateToProfile={handleNavigateToProfile}
    />
  );
};
